import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import api from '../services/api';
import { FiEdit, FiTrash, FiBookOpen, FiUsers, FiCheck } from 'react-icons/fi';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';

const AnneesScolairesPage = () => {
    const [annees, setAnnees] = useState([]);
    const [form, setForm] = useState({
    annee_scolaire: '',
    ouverte: 'N',
    ouvrirClasses: false,
    associerMatieresProfs: false
  });
    const [editingId, setEditingId] = useState(null);
    const [page, setPage] = useState(1);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const pageSize = 10;
    const totalPages = Math.ceil(annees.length / pageSize) || 1;
    const paginatedAnnees = annees.slice((page - 1) * pageSize, page * pageSize);

  const fetchAnnees = async () => {
    const res = await api.get('/annees-scolaires');
    setAnnees(res.data.data || []);
  };

  useEffect(() => { fetchAnnees(); }, []);

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoadingCreate(true);
  try {
        if (editingId) {
        await api.put(`/annees-scolaires/${editingId}`, form);
        } else {
        const res = await api.post('/annees-scolaires', {
            ...form,
            ouvrir_classes: form.ouvrirClasses ? 1 : 0,
            associer_matieres_profs: form.associerMatieresProfs ? 1 : 0
        });
        // GESTION ERREUR DEDOULEE
        if (res.data && res.data.success === false && res.data.message && res.data.message.includes('existe déjà')) {
            Swal.fire({
            icon: 'warning',
            title: "Doublon",
            text: res.data.message,
            });
            setLoadingCreate(false);
            return;
        }
        if (res.data && res.data.success) {
            Swal.fire({
                icon: 'success',
                title: 'Succès',
                text: res.data.message,
                timer: 3000,
                showConfirmButton: false
            });
        }
        }
        setForm({ annee_scolaire: '', ouverte: 'N' });
        setEditingId(null);
        fetchAnnees();
        setPage(1);
    } catch (err) {
            Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: (err.response && err.response.data && err.response.data.message) || 'Erreur inattendue.',
            confirmButtonText: 'OK'
            });
    } finally {
        setLoadingCreate(false);
    }
};

  const remove = async (id) => {
    try{
    await api.delete(`/annees-scolaires/${id}`);
    fetchAnnees();
    setPage(1);
    } catch (err) {
        if (err.response && err.response.status === 403) {
            Swal.fire({
            icon: 'error',
            title: 'Accès interdit',
            text: "Vous n'avez pas la permission pour effectuer cette action.",
            confirmButtonText: 'OK'
            });
        } else {
            // gestion des autres erreurs
            Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: (err.response && err.response.data && err.response.data.message) || 'Erreur inattendue.',
            confirmButtonText: 'OK'
            });
        }
    }
  };
  return (
    <div className="max-w-3xl mx-auto p-4">
      <h2 className="text-xl font-bold mb-2 text-gray-900 dark:text-gray-100">Années scolaires</h2>
      <form className="mb-6 flex flex-col gap-2 items-start w-full" onSubmit={handleSubmit}>
        <div className="flex gap-4 w-full">
          <div className="flex-1">
            <label className="block mb-1 dark:text-gray-200">Année scolaire</label>
            <input className="border rounded px-2 py-1 w-full dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200" required
              value={form.annee_scolaire}
              onChange={e => setForm(f => ({...f, annee_scolaire: e.target.value}))}
              placeholder="2024-2025"
              maxLength={9}
            />
          </div>
          <div className="flex-1">
            <label className="block mb-1 dark:text-gray-200">Ouverte</label>
            <select className="border rounded px-2 py-1 w-full dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200" value={form.ouverte}
              onChange={e => setForm(f => ({...f, ouverte: e.target.value}))}>
              <option value="N">Non</option>
              <option value="Y">Oui</option>
            </select>
          </div>
        </div>
        <div className="mt-4 mb-4 w-full grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Checkbox 1: Ouvrir les classes */}
          <label className={`relative flex items-start p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
            form.ouvrirClasses
              ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20 shadow-md'
              : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-primary-300 dark:hover:border-primary-700 hover:shadow-sm'
          }`}>
            <div className="flex items-start space-x-3 flex-1">
              <div className="relative flex-shrink-0 mt-0.5">
                <input
                  type="checkbox"
                  className="sr-only"
                  checked={form.ouvrirClasses}
                  onChange={e => setForm(f => ({ ...f, ouvrirClasses: e.target.checked }))}
                />
                <div className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-all duration-200 ${
                  form.ouvrirClasses
                    ? 'bg-primary-600 border-primary-600 dark:bg-primary-500 dark:border-primary-500'
                    : 'bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600'
                }`}>
                  {form.ouvrirClasses && (
                    <FiCheck className="w-4 h-4 text-white" />
                  )}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 mb-1">
                  <FiBookOpen className={`w-5 h-5 ${form.ouvrirClasses ? 'text-primary-600 dark:text-primary-400' : 'text-gray-400 dark:text-gray-500'}`} />
                  <span className={`text-sm font-semibold ${
                    form.ouvrirClasses
                      ? 'text-primary-900 dark:text-primary-200'
                      : 'text-gray-700 dark:text-gray-300'
                  }`}>
                    Ouvrir les classes avec l'année
                  </span>
                </div>
                <p className="text-xs text-gray-500 dark:text-gray-400">
                  Créer automatiquement les ouvertures de classes pour cette année
                </p>
              </div>
            </div>
          </label>

          {/* Checkbox 2: Associer matières et professeurs */}
          <label className={`relative flex items-start p-4 rounded-lg border-2 transition-all duration-200 ${
            form.associerMatieresProfs
              ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20 shadow-md'
              : form.ouvrirClasses
                ? 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-primary-300 dark:hover:border-primary-700 hover:shadow-sm cursor-pointer'
                : 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 opacity-60 cursor-not-allowed'
          }`}>
            <div className="flex items-start space-x-3 flex-1">
              <div className="relative flex-shrink-0 mt-0.5">
                <input
                  type="checkbox"
                  className="sr-only"
                  checked={form.associerMatieresProfs}
                  onChange={e => setForm(f => ({ ...f, associerMatieresProfs: e.target.checked }))}
                  disabled={!form.ouvrirClasses}
                />
                <div className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-all duration-200 ${
                  form.associerMatieresProfs
                    ? 'bg-primary-600 border-primary-600 dark:bg-primary-500 dark:border-primary-500'
                    : form.ouvrirClasses
                      ? 'bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600'
                      : 'bg-gray-100 dark:bg-gray-800 border-gray-300 dark:border-gray-700'
                }`}>
                  {form.associerMatieresProfs && (
                    <FiCheck className="w-4 h-4 text-white" />
                  )}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center space-x-2 mb-1">
                  <FiUsers className={`w-5 h-5 ${
                    form.associerMatieresProfs
                      ? 'text-primary-600 dark:text-primary-400'
                      : form.ouvrirClasses
                        ? 'text-gray-400 dark:text-gray-500'
                        : 'text-gray-300 dark:text-gray-600'
                  }`} />
                  <span className={`text-sm font-semibold ${
                    form.associerMatieresProfs
                      ? 'text-primary-900 dark:text-primary-200'
                      : form.ouvrirClasses
                        ? 'text-gray-700 dark:text-gray-300'
                        : 'text-gray-400 dark:text-gray-500'
                  }`}>
                    Associer les matières et professeurs
                  </span>
                </div>
                <p className={`text-xs ${
                  form.ouvrirClasses
                    ? 'text-gray-500 dark:text-gray-400'
                    : 'text-gray-400 dark:text-gray-600'
                }`}>
                  {form.ouvrirClasses
                    ? 'Lier automatiquement les matières et professeurs aux classes'
                    : 'Activez d\'abord l\'ouverture des classes'}
                </p>
              </div>
            </div>
          </label>
        </div>
        <div className="flex items-end justify-end w-full">
            <ConditionalButton
                entity="annees"
                permission={editingId ? "update" : "create"}
                type="submit"
                disabled={loadingCreate}
                className={
                    editingId
                        ? "bg-primary-600 text-white px-3 py-1 rounded hover:bg-primary-700 transition"
                        : "bg-primary-600 text-white px-3 py-1 rounded hover:bg-primary-700 transition"
                }
            >
            {loadingCreate && (
                <svg className="animate-spin h-4 w-4 text-white inline mr-2" viewBox="0 0 24 24" fill="none">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"/>
                </svg>
            )}
            {editingId ? 'Modifier l\'année scolaire' : 'Ajouter une année scolaire'}
            </ConditionalButton>
        </div>
        {editingId && (
          <button
            type="button"
            onClick={() => { setEditingId(null); setForm({ annee_scolaire: '', ouverte: 'N' }); }}
            className="ml-2 px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition text-gray-700"
          >
            Annuler
          </button>
        )}
      </form>
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden mt-8">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-700">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Année scolaire</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Ouverte</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {paginatedAnnees.length === 0 ? (
              <tr>
                <td colSpan="3" className="px-6 py-4 text-center text-gray-500 dark:text-gray-400">
                  Aucune année scolaire trouvée
                </td>
              </tr>
            ) : (
              paginatedAnnees.map(a => (
                <tr key={a.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/80 transition-colors duration-150">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-200">
                    {a.annee_scolaire}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-center text-gray-500 dark:text-gray-300">
                    <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                      a.ouverte === 'Y' 
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' 
                        : 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300'
                    }`}>
                      {a.ouverte === 'Y' ? 'Oui' : 'Non'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-center">
                    <ConditionalActions
                      entity="annees"
                      onEdit={() => { setEditingId(a.id); setForm({ annee_scolaire: a.annee_scolaire, ouverte: a.ouverte }); }}
                      onDelete={() => remove(a.id)}
                      editIcon={FiEdit}
                      deleteIcon={FiTrash}
                      className="flex space-x-1 justify-center"
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-center items-center gap-1 mt-4 flex-wrap pb-4">
        <button onClick={() => setPage(1)} disabled={page === 1} className="px-2 py-1 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 text-sm">Premier</button>
        <button onClick={() => setPage(page - 1)} disabled={page === 1} className="px-2 py-1 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 text-sm">Précédent</button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
            <button
            key={p}
            className={`px-2 py-1 rounded mx-0.5 text-sm ${p === page ? 'bg-primary-600 text-white' : 'bg-gray-100 dark:bg-gray-700 dark:text-gray-200 hover:bg-primary-100 dark:hover:bg-gray-600 text-gray-700'}`}
            onClick={() => setPage(p)}
            disabled={p === page}
            >{p}</button>
        ))}
        <button onClick={() => setPage(page + 1)} disabled={page === totalPages} className="px-2 py-1 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 text-sm">Suivant</button>
        <button onClick={() => setPage(totalPages)} disabled={page === totalPages} className="px-2 py-1 rounded bg-gray-200 dark:bg-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50 text-sm">Dernier</button>
        </div>
    </div>
  );
};

export default AnneesScolairesPage;